import { StyleSheet } from 'react-native';
import { PROFILE_COLORS } from '../ProfileScreen/ProfileScreen.constants';

export const dailyRewardsCardStyles = StyleSheet.create({
  card: {
    marginHorizontal: 16,
    marginTop: 14,
    backgroundColor: PROFILE_COLORS.card,
    borderWidth: 1,
    borderColor: PROFILE_COLORS.cardBorder,
    borderRadius: 16,
    padding: 16,
    gap: 14,
  },
  headerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  headerTitle: {
    fontSize: 15,
    fontWeight: '700',
    color: PROFILE_COLORS.text,
  },
  headerCount: {
    fontSize: 12,
    color: PROFILE_COLORS.textMuted,
    fontVariant: ['tabular-nums'],
  },
  headerCountStrong: {
    color: PROFILE_COLORS.gold,
    fontWeight: '700',
  },
  ladderRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  dayCol: {
    flex: 1,
    alignItems: 'center',
    gap: 6,
  },
  dayLabel: {
    fontSize: 10,
    fontWeight: '700',
    color: PROFILE_COLORS.textDim,
  },
  dayLabelActive: {
    color: PROFILE_COLORS.gold,
  },
  node: {
    width: 38,
    height: 38,
    borderRadius: 9999,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: PROFILE_COLORS.nodeIdle,
    borderWidth: 1,
    borderColor: PROFILE_COLORS.cardBorder,
  },
  nodeClaimed: {
    backgroundColor: PROFILE_COLORS.gold,
    borderColor: PROFILE_COLORS.gold,
  },
  nodeToday: {
    backgroundColor: PROFILE_COLORS.nodeTodayBg,
    borderWidth: 2,
    borderColor: PROFILE_COLORS.gold,
  },
  coinDot: {
    width: 20,
    height: 20,
    borderRadius: 9999,
    backgroundColor: PROFILE_COLORS.gold,
  },
  dayAmount: {
    fontSize: 10,
    fontWeight: '700',
    color: PROFILE_COLORS.textDim,
    fontVariant: ['tabular-nums'],
  },
  dayAmountClaimed: {
    color: PROFILE_COLORS.gold,
  },
  dayAmountToday: {
    color: PROFILE_COLORS.text,
  },
  collectBtn: {
    minHeight: 44,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: PROFILE_COLORS.gold,
  },
  collectBtnPressed: { opacity: 0.85 },
  collectBtnHover: { opacity: 0.92 },
  collectBtnDisabled: {
    minHeight: 44,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: PROFILE_COLORS.buttonIdleBg,
    borderWidth: 1,
    borderColor: PROFILE_COLORS.buttonIdleBorder,
  },
  collectText: {
    fontSize: 15,
    fontWeight: '800',
    color: '#1A202C',
  },
  collectTextDisabled: {
    fontSize: 14,
    fontWeight: '700',
    color: PROFILE_COLORS.textMuted,
    fontVariant: ['tabular-nums'],
  },
});
